import React from "react";
import { Row, Col, Form, Select, Input, Button, DatePicker } from "antd";
import { AUDIT_OPTIONS } from "./util";

const DATE_FORMAT = "YYYY-MM-DD";

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

const Option = Select.Option;

const Search = (props) => {
  const { form, onSearch = () => {} } = props;

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        if (values.time && Array.isArray(values.time)) {
          values.beginTime = values.time?.[0]?.format(DATE_FORMAT);
          values.endTime = values.time?.[1]?.format(DATE_FORMAT);
          delete values.time;
        }
        onSearch(values);
      }
    });
  };

  return (
    <div className="ml-32 pl-24 pr-24 bg-white pt-16 pb-16 bd-line mt-24 mr-32">
      <Row>
        <Col span={20}>
          <Form layout="inline">
            <Form.Item>
              {form.getFieldDecorator("time", {})(<RangePicker />)}
            </Form.Item>
            <Form.Item>
              {form.getFieldDecorator(
                "brandCompanyName",
                {}
              )(
                <Input style={{ width: 180 }} placeholder="品牌商" allowClear />
              )}
            </Form.Item>
            {/* Audit status */}
            <Form.Item>
              {form.getFieldDecorator(
                "state",
                {}
              )(
                <Select
                  style={{ width: 158 }}
                  placeholder="审核状态"
                  allowClear
                >
                  {AUDIT_OPTIONS.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSubmit}>
                搜索
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default Form.create()(Search);
